define(["react","underscore","prop-types","hoist-non-react-statics","@bingads-webui-react/hoc-utils","react-router-dom","urijs","history","react-is"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__119__, __WEBPACK_EXTERNAL_MODULE__120__, __WEBPACK_EXTERNAL_MODULE__176__, __WEBPACK_EXTERNAL_MODULE__321__, __WEBPACK_EXTERNAL_MODULE__969__, __WEBPACK_EXTERNAL_MODULE__976__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 966);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__119__;

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__120__;

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__176__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__321__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(967);


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Router: true,
  MemoryRouter: true,
  HashRouter: true,
  Route: true,
  Link: true,
  withRouter: true,
  createWebHistory: true
};
Object.defineProperty(exports, "Router", {
  enumerable: true,
  get: function get() {
    return _router.Router;
  }
});
Object.defineProperty(exports, "MemoryRouter", {
  enumerable: true,
  get: function get() {
    return _router.MemoryRouter;
  }
});
Object.defineProperty(exports, "HashRouter", {
  enumerable: true,
  get: function get() {
    return _router.HashRouter;
  }
});
Object.defineProperty(exports, "Route", {
  enumerable: true,
  get: function get() {
    return _route.Route;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _link.Link;
  }
});
Object.defineProperty(exports, "withRouter", {
  enumerable: true,
  get: function get() {
    return _withRouter.withRouter;
  }
});
Object.defineProperty(exports, "createWebHistory", {
  enumerable: true,
  get: function get() {
    return _createWebHistory.createWebHistory;
  }
});

var _router = __webpack_require__(968);

var _route = __webpack_require__(974);

var _link = __webpack_require__(977);

var _withRouter = __webpack_require__(978);

var _createWebHistory = __webpack_require__(970);

var _historyProcessors = __webpack_require__(971);

Object.keys(_historyProcessors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _historyProcessors[key];
    }
  });
});

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HashRouter = exports.MemoryRouter = exports.Router = exports.RouterConsumer = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _history = __webpack_require__(969);

var _reactRouterDom = __webpack_require__(176);

var _createWebHistory = __webpack_require__(970);

var _identityParseRoute = __webpack_require__(973);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const routerConfigKeys = ['parseRoute'];
/**
 * React context storing the router configuration object.
 */

const RouterContext = _react.default.createContext({
  [routerConfigKeys]: _underscore.default.noop
});

const RouterConsumer = RouterContext.Consumer;
/**
 * Wrapper around React Router that allows some customization to the default router
 * behavior.
 * @param {object} props - Router configuration options
 * @returns {object}     - Configured router component
 */

exports.RouterConsumer = RouterConsumer;

const Router = props => {
  const routerConfig = _underscore.default.pick(props, routerConfigKeys);

  const remainingProps = _underscore.default.omit(props, routerConfigKeys);

  return _react.default.createElement(RouterContext.Provider, {
    value: routerConfig
  }, _react.default.createElement(_reactRouterDom.Router, remainingProps));
};
/*
 * The public API for a <Router> that stores location in memory for testing purpose.
 */


exports.Router = Router;

const MemoryRouter = props => {
  const history = (0, _history.createMemoryHistory)(props);

  const routerConfig = _underscore.default.pick(props, routerConfigKeys);

  return _react.default.createElement(Router, _extends({
    history: history
  }, routerConfig), props.children);
};
/*
 * The public API for a <Router> that uses window.location.hash.
 */


exports.MemoryRouter = MemoryRouter;

const HashRouter = props => {
  const history = (0, _history.createHashHistory)(props);

  const routerConfig = _underscore.default.pick(props, routerConfigKeys);

  return _react.default.createElement(Router, _extends({
    history: history
  }, routerConfig), props.children);
};

exports.HashRouter = HashRouter;
Router.propTypes = {
  /**
   * Function that parses the route props provided by React Router into the desired props
   * to send to route-consuming components.
   */
  parseRoute: _propTypes.default.func,

  /**
   * History object used by React Router for managing history and navigation.
   */
  history: _propTypes.default.shape()
};
Router.defaultProps = {
  parseRoute: _identityParseRoute.identityParseRoute,
  history: (0, _createWebHistory.createWebHistory)()
};
MemoryRouter.propTypes = {
  parseRoute: _propTypes.default.func,
  children: _propTypes.default.node
};
MemoryRouter.defaultProps = {
  parseRoute: _identityParseRoute.identityParseRoute,
  children: null
};
HashRouter.propTypes = {
  parseRoute: _propTypes.default.func,
  children: _propTypes.default.node
};
HashRouter.defaultProps = {
  parseRoute: _identityParseRoute.identityParseRoute,
  children: null
};

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__969__;

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWebHistory = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _urijs = _interopRequireDefault(__webpack_require__(321));

var _history = __webpack_require__(969);

var _historyProcessors = __webpack_require__(971);

var _historyNavigation = __webpack_require__(972);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a history object compatible with React Router <Router /> that handles both
 * server-side (full-page redirect) and client-side (React Router) routing.
 * This function extends and adds properties defined on the React Router default
 * browser history API.
 * @param {object} options          - Configuration options for the history object
 * @param {string} options.basename - Base path for routing that is passed to the React
 *                                    Router browser history
 * @param {function[]} processors   - A list of processors passed in from the App. The order
 * matters, i.e the last processor is always overriding previous values.
 * Each processors received the args (path, options = { previousNavigationObject })
 * @returns {object}                - History object compatible with React Router
 */
const createWebHistory = ({
  basename,
  processors = []
} = {}) => {
  const history = (0, _history.createBrowserHistory)({
    basename
  });
  const clientSidePush = history.push;
  const clientSideReplace = history.replace;
  /**
   * Store the basename for public reference where needed.
   */

  Object.defineProperty(history, 'basename', {
    get: () => basename
  });

  const serverOrClientSideNavigation = ({
    serverSideNavigation,
    clientSideNavigation,
    path,
    state
  }) => {
    const navigationObject = (0, _historyProcessors.getNavigationObject)({
      processors,
      path,
      basename
    });

    if (navigationObject[_historyProcessors.navigationObjectFormat.forceRefresh] === true) {
      serverSideNavigation(navigationObject[_historyProcessors.navigationObjectFormat.path]);
    } else {
      clientSideNavigation(navigationObject[_historyProcessors.navigationObjectFormat.path], _underscore.default.extend({
        previousRoute: window.location.href
      }, state));
    }
  };
  /**
   * Updated push method that performs a server-side redirect if the path given is an absolute URL
   * and a client-side redirect otherwise.
   * @param {string | object} path - a string indicating the navigation URL, or an object
   *                                 describing a path per the history API
   * @param {object} state         - state to send along with the history location object
   * @returns {void}
   */


  history.push = (path, state) => serverOrClientSideNavigation({
    serverSideNavigation: _historyNavigation.serverSidePush,
    clientSideNavigation: clientSidePush,
    path,
    state
  });

  history.replace = (path, state) => serverOrClientSideNavigation({
    serverSideNavigation: _historyNavigation.serverSideReplace,
    clientSideNavigation: clientSideReplace,
    path,
    state
  });
  /**
   * Patch the current search query in the URL according to the given params.
   * @param {object} params - patch updates to the current query params in the URL
   * @returns {void}
   */


  history.setSearch = params => {
    const search = (0, _urijs.default)(history.location.search).setSearch(params).query();
    history.push({
      search
    });
  };

  return history;
};

exports.createWebHistory = createWebHistory;

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigationObject = exports.normalizeServerSideNavigationProcessor = exports.absoluteUrlProcessor = exports.reduceProcessor = exports.createHref = exports.normalizeBasename = exports.navigationObjectFormat = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _urijs = _interopRequireDefault(__webpack_require__(321));

var _history = __webpack_require__(969);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NavigationObject object
 * @typedef {object} NavigationObject
 * @property {bool} [forceRefresh] the value indicating to force the navigation to
 * proceed to refresh (aka server-side redirection) if set to true
 * @property {string|object} [path] the path or location object to navigate to
 */

/**
 * pilot model for NavigationObject properties
 */
const navigationObjectFormat = {
  forceRefresh: 'forceRefresh',
  path: 'path',
  basename: 'basename'
};
/**
 * Ensure that each basename start with a slash and do not end with a slash
 * @param {string} basename the string basename given to the router
 * @return {string} the expected basename react-router is actually using for navigation
 */

exports.navigationObjectFormat = navigationObjectFormat;

const normalizeBasename = basename => {
  const addLeadingSlash = b => b.charAt(0) === '/' ? b : `/${b}`;

  const stripTrailingSlash = b => b.charAt(b.length - 1) === '/' ? b.slice(0, -1) : b;

  return basename ? stripTrailingSlash(addLeadingSlash(basename)) : '';
};
/**
 * We consider to add the basename only if there is a basename in param and the url is relative
 * Returns true if the relative path doesn't start with the basename
 * @param {string} path the path to navigate to
 * @param {string} basename the string basename given to the router
 * @return {boolean} true if the path doesn't start with the basename or is not relative
 */


exports.normalizeBasename = normalizeBasename;

const pathIsRelativeAndNeedBasename = (path, basename) => {
  const uri = (0, _urijs.default)(path);

  if (!basename || uri.is('absolute')) {
    return false;
  }

  const firstPathSegment = _underscore.default.first(uri.segment());

  const basenameSegment = _underscore.default.first((0, _urijs.default)(basename).segment());

  return firstPathSegment !== basenameSegment;
};
/**
 * createHref exists in the source code of react-router's `history`
 * but was not externalized so it is forked here.
 * @param {object|string} locationOrPath the location object or path to navigate to
 * @param {string} basename the string basename given to the router
 * @return {string} the href string from the basename and the location object in parameter,
 * leveraging react-router's `history` createPath function
 */


const createHref = (locationOrPath, basename) => {
  const path = _underscore.default.isObject(locationOrPath) ? (0, _history.createPath)(locationOrPath) : locationOrPath;

  if (pathIsRelativeAndNeedBasename(path, basename)) {
    return normalizeBasename(basename) + path;
  }

  return path;
};
/**
 * Override memo with the processor function callback.
 * Processor can return a boolean to force refresh or not, or return an entire NavigationObject.
 * Each processor will receive in parameter the path we are about to navigate to,
 * and the previous NavigationObject for reference.
 * @param {NavigationObject} previousNavigationObject The previous NavigationObject
 * @param {function} processor The function callback that make some navigation switch decision
 * @return {NavigationObject} The new navigationObject from the processor result
 */


exports.createHref = createHref;

const reduceProcessor = (previousNavigationObject, processor) => {
  const result = _underscore.default.isFunction(processor) ? processor(previousNavigationObject[navigationObjectFormat.path], {
    previousNavigationObject
  }) : null;

  if (_underscore.default.isBoolean(result)) {
    return _underscore.default.extend({}, previousNavigationObject, {
      [navigationObjectFormat.forceRefresh]: result
    });
  }

  if (_underscore.default.isObject(result)) {
    const navigationObject = _underscore.default.pick(result, _underscore.default.values(navigationObjectFormat));

    return _underscore.default.extend({}, previousNavigationObject, navigationObject);
  }

  return previousNavigationObject;
};
/**
 * Force refresh (aka server side redirect) for location object or string path with absolute URL
 * @param {object|string} path The path or location object to navigate to
 * @return {NavigationObject} The { forceRefresh:true, path } NavigationObject if path is absolute,
 * or null otherwise.
 */


exports.reduceProcessor = reduceProcessor;

const absoluteUrlProcessor = path => {
  const location = (0, _history.createLocation)(path);
  const uri = (0, _urijs.default)(location.pathname);

  if (uri.is('absolute')) {
    if (location.search) {
      uri.search(location.search);
    }

    return {
      [navigationObjectFormat.forceRefresh]: true,
      [navigationObjectFormat.path]: uri.toString()
    };
  }

  return null;
};
/**
 * Ensure that if forceRefresh=true, we return a correct stringified Path with the basename
 * for a correct server side redirect. Server side redirect can't navigate with object in parameter
 * @param {object|string} path The path or location object to navigate to
 * @param {NavigationObject} previousNavigationObject The previous NavigationObject passed in
 * @return {NavigationObject} The { path: path.toString() } NavigationObject if forceRefresh==true
 * and path is an object, or null otherwise
 */


exports.absoluteUrlProcessor = absoluteUrlProcessor;

const normalizeServerSideNavigationProcessor = (path, {
  previousNavigationObject
}) => {
  if (previousNavigationObject[navigationObjectFormat.forceRefresh] === true) {
    const basename = previousNavigationObject[navigationObjectFormat.basename];
    return {
      [navigationObjectFormat.path]: createHref(path, basename)
    };
  }

  return null;
};
/**
 * A list of processors from params will be evaluated, in order of importance, to finally
 * return the last NavigationObject before proceed with the navigation.
 * This function always finish by evaluating the absoluteUrlProcessor
 * and normalizeServerSideNavigationProcessor, in this order.
 * @param {function[]} processors A list of processors passed in from the App. The order matters:
 * the last processor is overriding previous processors
 * @return {NavigationObject} The { path, forceRefresh } NavigationObject to help in the navigation
 */


exports.normalizeServerSideNavigationProcessor = normalizeServerSideNavigationProcessor;

const getNavigationObject = ({
  processors,
  path,
  basename
}) => _underscore.default.reduce([...processors, ...[absoluteUrlProcessor, normalizeServerSideNavigationProcessor]], reduceProcessor, {
  forceRefresh: false,
  path,
  basename
});

exports.getNavigationObject = getNavigationObject;

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverSideReplace = exports.serverSidePush = void 0;

// Externalize those 2 functions for mocking conveniance in unit tests
const serverSidePush =
/* istanbul ignore next */
url => {
  window.location.href = url;
};

exports.serverSidePush = serverSidePush;

const serverSideReplace =
/* istanbul ignore next */
url => {
  window.location.replace(url);
};

exports.serverSideReplace = serverSideReplace;

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identityParseRoute = void 0;

/**
 * Identity function that just returns the original route props provided by React Router
 * without any modifications.
 * @param {object} routeProps - Route props provided by React Router
 * @returns {object}          - The same route props without any transformation
 */
const identityParseRoute = ({
  location,
  match
}) => ({
  location,
  match
});

exports.identityParseRoute = identityParseRoute;

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Route = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _reactRouterDom = __webpack_require__(176);

var _propTypesExt = __webpack_require__(975);

var _router = __webpack_require__(968);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const convertProps = ({
  routerConfig: {
    parseRoute
  },
  routeProps
}) => {
  const params = parseRoute(routeProps);
  return _underscore.default.defaults({}, routeProps, params);
};
/**
 * Extension of the React Router <Route /> component that maps the default React Router
 * route props into new props according to the router config, then passes these to the
 * wrapped component.
 * Similar to React Router <Route />, the wrapped component can be passed in through the
 * "component", "render", and "children" props.
 * All other props will be passed through down to React Router <Route />.
 * @param {object} props - Route component props
 * @returns {object}     - Component with route context
 */


const Route = props => _react.default.createElement(_router.RouterConsumer, null, routerConfig => {
  const updatedProps = _underscore.default.extend({}, props);

  if (props.component) {
    updatedProps.component = routeProps => _react.default.createElement(props.component, convertProps({
      routerConfig,
      routeProps
    }));
  }

  if (props.render) {
    updatedProps.render = routeProps => props.render(convertProps({
      routerConfig,
      routeProps
    }));
  }

  if (props.children) {
    updatedProps.children = routeProps => props.children(convertProps({
      routerConfig,
      routeProps
    }));
  }

  return _react.default.createElement(_reactRouterDom.Route, updatedProps);
});

exports.Route = Route;
Route.propTypes = {
  children: _propTypes.default.func,
  // Bug in eslint: https://github.com/yannickcr/eslint-plugin-react/issues/1389
  // eslint-disable-next-line react/no-typos
  component: _propTypesExt.PropTypesExt.component,
  render: _propTypes.default.func
};
Route.defaultProps = {
  children: null,
  component: null,
  render: null
};

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropTypesExt = void 0;

var _reactIs = __webpack_require__(976);

const PropTypesExt = {
  component: (props, propName, componentName) => {
    if (props[propName] && !(0, _reactIs.isValidElementType)(props[propName])) {
      return new Error(`Invalid prop ${propName} supplied to ${componentName}`);
    }

    return null;
  }
};
exports.PropTypesExt = PropTypesExt;

/***/ }),

/***/ 976:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__976__;

/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _urijs = _interopRequireDefault(__webpack_require__(321));

var _history = __webpack_require__(969);

var _reactRouterDom = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Extension of the React Router <Link /> component that prevent absolute URL href to be overrided
 * by React Router <Link /> by rendering a basic anchor DOM
 * Usage similar to <Link /> components: https://reactrouter.com/web/api/Link
 * @param {object} props - <Link /> component props
 * @returns {object}     - <Link /> component or anchor component for absolute URLs
 */
const Link = props => {
  const to = props.to,
        rest = _objectWithoutProperties(props, ["to"]);

  const path = _underscore.default.isObject(to) ? (0, _history.createPath)(to) : to;

  if (_underscore.default.isString(path) && (0, _urijs.default)(path).is('absolute')) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return _react.default.createElement("a", _extends({}, rest, {
      href: path
    }));
  }

  return _react.default.createElement(_reactRouterDom.Link, props);
};

exports.Link = Link;
Link.propTypes = {
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func]).isRequired
};

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRouter = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(119));

var _hocUtils = __webpack_require__(120);

var _route = __webpack_require__(974);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * HOC that passes the mapped React Route route props to the wrapped component.
 * @param {object} WrappedComponent - Component to receive mapped route props
 * @returns {object} - Component with mapped route props
 */
const withRouter = WrappedComponent => {
  const RoutedComponent = props => {
    /* eslint-disable react/prop-types */
    const rest = _underscore.default.omit(props, 'forwardedRef');

    return _react.default.createElement(_route.Route, null, routeComponentProps => _react.default.createElement(WrappedComponent, _extends({}, rest, routeComponentProps, {
      ref: props.forwardedRef
    })));
  };

  RoutedComponent.displayName = `withBingAdsRouter(${(0, _hocUtils.getDisplayName)(WrappedComponent)})`;
  (0, _hoistNonReactStatics.default)(RoutedComponent, WrappedComponent);
  return _react.default.forwardRef((props, ref) => _react.default.createElement(RoutedComponent, _extends({}, props, {
    forwardedRef: ref
  })));
};

exports.withRouter = withRouter;

/***/ })

/******/ })});;
